// Modal Management

import { config, state } from './config.js';
import { clearFormError } from './forms.js';
import { resetTurnstileWidget, initCheckoutTurnstile, initEnterpriseTurnstile } from './turnstile.js';
import { showToast } from '../../shared/js/toast.js';

// Re-export shared modal utilities
export { openModal, closeModal } from '../../shared/js/modals.js';

/**
 * Close modal with common cleanup
 */
export function closeModalWithCleanup(modalId, formId, errorFields, turnstileWidgetId, restoreFocus) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    modal.classList.remove('active');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    const form = document.getElementById(formId);
    if (form) form.reset();

    errorFields.forEach(field => {
        clearFormError(field, field + 'Error');
    });

    if (turnstileWidgetId !== null) {
        resetTurnstileWidget(turnstileWidgetId);
    }

    if (restoreFocus && typeof restoreFocus.focus === 'function') {
        restoreFocus.focus();
    }
}

/**
 * Open checkout modal
 */
export function checkout(edition) {
    state.selectedEdition = edition;
    const editionInfo = config.editions[edition];

    if (!editionInfo) {
        showToast('Invalid plan selected', 'error');
        return;
    }

    const period = state.isAnnualBilling ? 'year' : 'month';
    let description = '';

    if (edition === 2 && state.extraSeats > 0) {
        const basePrice = state.isAnnualBilling ? editionInfo.annualPrice : editionInfo.monthlyPrice;
        const extraCost = state.extraSeats * (state.isAnnualBilling ? config.extraSeatPrice.annual : config.extraSeatPrice.monthly);
        const totalPrice = basePrice + extraCost;
        const totalSeats = editionInfo.baseSeats + state.extraSeats;
        description = `${editionInfo.name} Plan (${totalSeats} seats) - $${totalPrice}/${period}`;
    } else {
        const price = state.isAnnualBilling ? editionInfo.annualPrice : editionInfo.monthlyPrice;
        description = `${editionInfo.name} Plan - $${price}/${period}`;
    }

    document.getElementById('modalPlanDescription').textContent = description;

    // Sync hidden form inputs
    const editionInput = document.getElementById('checkoutEdition');
    const billingInput = document.getElementById('checkoutBillingPeriod');
    const seatsInput = document.getElementById('checkoutSeats');
    if (editionInput) editionInput.value = edition;
    if (billingInput) billingInput.value = state.isAnnualBilling ? 'annual' : 'monthly';
    if (seatsInput) seatsInput.value = edition === 2 ? (config.editions[2].baseSeats + state.extraSeats) : 1;

    state.previouslyFocusedElement = document.activeElement;

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.getElementById('checkoutModal').classList.add('active');
    document.getElementById('checkoutEmail').focus();

    initCheckoutTurnstile();

}

/**
 * Close checkout modal
 */
export function closeCheckoutModal() {
    closeModalWithCleanup(
        'checkoutModal',
        'checkoutForm',
        ['checkoutEmail', 'checkoutTurnstile'],
        state.checkoutTurnstileWidgetId,
        state.previouslyFocusedElement
    );
    state.selectedEdition = null;
    state.previouslyFocusedElement = null;
}

/**
 * Open enterprise inquiry modal
 */
export function openEnterpriseModal() {
    const modal = document.getElementById('enterpriseModal');
    if (modal) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        modal.classList.add('active');
        document.getElementById('enterpriseCompany').focus();
        initEnterpriseTurnstile();
    }
}

/**
 * Close enterprise inquiry modal
 */
export function closeEnterpriseModal() {
    closeModalWithCleanup(
        'enterpriseModal',
        'enterpriseForm',
        ['enterpriseCompany', 'enterpriseName', 'enterpriseEmail', 'enterpriseSeats', 'enterpriseTurnstile'],
        state.enterpriseTurnstileWidgetId,
        null
    );
}
